import React, { useEffect, useState } from 'react'
import { Container } from 'react-bootstrap'
import { useParams, useHistory } from 'react-router-dom'
import './PostsStyle.css'
import axios from 'axios'

import Loader from 'react-loader-spinner'
import { NavBar } from '../../Components/Navigation/NavBar'
import { Footer } from '../../Components/Footer/Footer'

const PostContent = () => {
  const history = useHistory()
  const [post, setPost] = useState([])
  const [renderPage, setRenderPage] = useState(false)
  const BASE_URL = 'https://www.googleapis.com/blogger/v3/blogs/'

  let { postId } = useParams()

  useEffect(() => {
    const getAllPosts = async () => {
      try {
        const response = await axios.get(
          BASE_URL +
            process.env.REACT_APP_BLOG_ID +
            '/posts/' +
            postId +
            '?key=' +
            process.env.REACT_APP_BLOG_API_KEY
        )
        // console.log(response.data.content)
        setPost(response.data)
        setRenderPage(true)
      } catch (err) {
        console.log(err)
        history.push('/')
      }
    }
    getAllPosts()
  },[postId,history])

  return (
    <div>
    <NavBar />
    <Container className="mt-4 text-dark py-3">
      {renderPage ? (
        post && (
          <div>
            <div>
              <head>{post.title}</head>
            </div>
            <div
              className="py-3"
              dangerouslySetInnerHTML={{ __html: post.content }}
              style={{ marginBottom: '15rem' }}
            ></div>
          </div>
        )
      ) : (
        <Loader
          type="TailSpin"
          color="teal"
          height={100}
          width={100}
          timeout={3000} //3 secs
          className="loader"
        />
      )}
    </Container>
    <Footer/>
  </div>
  )
}

export default PostContent
